import React, { useState } from "react";
import { Helmet } from "react-helmet";
import InteractiveDemoConsole from "../components/universal/InteractiveDemoConsole/InteractiveDemoConsole";

const testProgram = `print("Be curious, experiment, and keep coding.");
const secret = Math.floor(Math.random() * 10) + 1;
let attempts = 0;
print("I'm thinking of a number between 1 and 10.");
while (true) {
  const answer = (await input("Your guess: ")).trim();
  const guess = Number(answer);
  if (answer === "" || !Number.isSafeInteger(guess)) {
    print("Please enter a whole number.");
    continue;
  }
  attempts += 1;
  if (guess < secret) {
    print("Too low. Try again!");
  } else if (guess > secret) {
    print("Too high. Try again!");
  } else {
    print("Correct! You guessed it in " + attempts + " attempts.");
    break;
  }
}`;

function InteractiveDemoConsoleTest() {
  const [theme, setTheme] = useState("default");
  return (
    <div className="interactive-demo-console-test-page">
      <Helmet>
        <title>Interactive Demo Console Test | Mission Encodeable</title>
      </Helmet>

      <div className="Header-box">
        <h1 className="Header-title darkgreen">Interactive demo console test</h1>
      </div>

      <label>
        Console theme: {" "}
        <select value={theme} onChange={(event) => setTheme(event.target.value)}>
          <option value="default">Mission Encodeable</option>
          <option value="summer">Summer coding challenges</option>
          <option value="christmas-red">Christmas — red and gold</option>
          <option value="christmas-green">Christmas — evergreen and lime</option>
          <option value="christmas-blue">Christmas — teal and ice blue</option>
        </select>
      </label>
      <InteractiveDemoConsole code={testProgram} title="Guess the number" theme={theme} />
    </div>
  );
}

export default InteractiveDemoConsoleTest;
